import UserApi from "./user";
import AdminApi from "./admin";

const api = {
    user: UserApi,
    admin: AdminApi
}

export default api;